var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"product-config"},[_c(_setup.CardInfo,_vm._g(_vm._b({ref:"cardInfoRef",attrs:{"data":_setup.formData}},'CardInfo',_vm.$attrs,false),_vm.$listeners)),_vm._v(" "),_c(_setup.RentPlan,{ref:"rentPlanRef",attrs:{"planIds":_setup.formData.planIds}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }